module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-44.dca7a360.png";